module.exports = __webpack_public_path__ + "static/media/Gilroy-ExtraBold.0f6e082f.otf";